import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';

@Component({
  selector: 'app-wind-icon',
  imports: [
    TextModule,
    PipesModule,
    NgOptimizedImage,
  ],
  templateUrl: './wind-icon.component.html',
  styleUrl: './wind-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WindIconComponent {
  windAngle = input<number>();
  windStrength = input<number>();

  windIcon = computed(() => {
    const windIndex = this.getWindIndex();
    return `/assets/wind-pins/dashboardno${windIndex}.png`;
  });

  noWindText = computed(() => {
    const windIndex = this.getWindIndex();
    if (windIndex === 0) {
      return 'app.__WIND_TOO_LOW';
    }
    return 'app.__WIND_NO_DIRECTION';
  });

  windColor = computed(() => {
    const windIndex = this.getWindIndex();

    const colorScale = [
      '#C0C0C0', '#83D6E0', '#5CC8DB', '#20B9D2', '#7FADBC', '#0BD794',
      '#77E205', '#F7BE1E', '#FF891F', '#F92919', '#FC5603', '#F92918',
    ];

    return colorScale[windIndex];
  });

  windDirection = computed(() => {
    const windAngle = this.windAngle();

    if (typeof windAngle === 'undefined') {
      return '--';
    }

    const scale = [0, 22.5, 67.5, 112.5, 157.5, 202.5, 247.5, 292.5, 337.5, 360];

    const dirScale = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW', 'N'];

    let dir = 0;
    for (let i = 0; i < scale.length; i++) {
      if (windAngle >= scale[i]) {
        dir = i;
      }
    }

    return dirScale[dir];
  });

  private getWindIndex(): number {
    if (!this.windStrength()) {
      return 0;
    }

    const scale = [5, 11, 19, 28, 38, 49, 61, 74, 88, 102, 117, Infinity];

    for (let i = 0; i < scale.length; i++) {
      if (this.windStrength() <= scale[i]) {
        return i;
      }
    }

    return 0;
  }
}
